import { useState, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput } from '../forms';
import { partnerOrderActions, PartnerOrderStore } from '../../../orders/store/partner/partnerOrderStore';

interface B2BCustomerSelectorProps extends ComponentProps<typeof SelectInput> {
    partnerOrderStore?: PartnerOrderStore,
  }

const B2BCustomerSelector = (props: B2BCustomerSelectorProps) => {
  const {
    partnerOrderStore,
    name,
    label,
    clearable,
    ...rest
  } = props;

  const { B2BCustomers } = partnerOrderStore;

  const [loading, setLoading] = useState(false);

  const loadData = () => {
    if (B2BCustomers.length === 0) {
      setLoading(true);
      partnerOrderActions.getB2BCustomers().finally(() => setLoading(false));
    }
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <SelectInput
      { ...rest }
      data={ B2BCustomers }
      dataTitle='name'
      dataValue='id'
      loading={ loading }
      sort
      name={ name }
      label={ label }
      clearable={ clearable }
    />
  );
};

export default inject('partnerOrderStore')(observer(B2BCustomerSelector));
